import { render } from "./Afiliados.vue?vue&type=template&id=626af562"
import script from "./Afiliados.vue?vue&type=script&lang=js"
export * from "./Afiliados.vue?vue&type=script&lang=js"

import "./Afiliados.vue?vue&type=style&index=0&id=626af562&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__